export default __webpack_public_path__ + "static/media/icon-close.aa57bc9a.svg";